import { render, staticRenderFns } from "./NewPromotionWizard.vue?vue&type=template&id=732b07ad&"
import script from "./NewPromotionWizard.vue?vue&type=script&lang=js&"
export * from "./NewPromotionWizard.vue?vue&type=script&lang=js&"
import style0 from "./NewPromotionWizard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports